import { create } from 'zustand';
import { checkSubscription, type SubscriptionStatus } from '../api/services';

interface SubscriptionState extends SubscriptionStatus {
  isLoading: boolean;
  error: string | null;
  initialize: () => Promise<void>;
  clearError: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>()((set) => ({
  isActive: false,
  plan: 'free',
  source: null,
  expiresAt: null,
  isLoading: true,
  error: null,

  initialize: async () => {
    set({ isLoading: true, error: null });
    try {
      const status = await checkSubscription();
      set({
        isActive: status.isActive,
        plan: status.plan,
        source: status.source ?? null,
        expiresAt: status.expiresAt ?? null,
        isLoading: false,
      });
    } catch (err) {
      set({
        isLoading: false,
        error: err instanceof Error ? err.message : 'Failed to load subscription',
      });
    }
  },

  clearError: () => set({ error: null }),
}));
